;(function($) {


    $('.js-langswitch').each(function () {
        var container = $(this),
            trigger = $(this).find('.langswitch__trigger'),
            menu = $(this).find('.langswitch__menu')

        $(document).click(function () {
            $(container).removeClass('is-active')
        })

        $(trigger).click(function (e) {
            e.stopPropagation()
            $(this).closest(container).toggleClass('is-active')
        })

        $(menu).find('a').click(function (e) {
            e.stopPropagation()
        })
    })


}(jQuery));
